<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Pencarian Faktur</h5>
            </template>
            <div class="form-content-wrapper mb-4">  
                <h6 class="form-title">SEARCH FAKTUR</h6>
                <div class="d-flex form-content-wrapper mb-4">
                    <b-form-group class="mr-2 mb-0">
                        <b-form-select class="mr-2" v-model="input.searchBy" id="searchBy" name="searchBy" :options="searchByOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group class="mr-2 mb-0">
                        <b-form-input class="mr-2" v-model="input.searchQuery" ref="inputFilterSearchQuery" v-on:keyup.enter="searchInquiryFaktur" name="filterTableQuery" placeholder="Pencarian…"></b-form-input>
                    </b-form-group>
                    <b-button variant="pgiBtn" name="searchTableBtn" @click="searchInquiryFaktur()"> 
                        <b-spinner small class="loading-spinner" v-if="isSearch"></b-spinner>
                        <i class="fa fa-search" v-else></i>
                    </b-button>
                </div>
                <div class="detail-data-wrapper mb-4" v-if="showListFromNoFaktur && !isSearch">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="daftarGadaiFromFaktur" 
                        :fields="fields" 
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data gadai.
                        </template>
                        <template v-slot:cell(noFaktur)="row">
                            <div class="no-wrap">{{ row.item.noFaktur }}</div>
                            <div class="no-wrap text-muted smallText">IMEI: {{ row.item.imeiSn }}</div>
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-badge variant="dark" v-if="row.item.status.name == 'Baru'">BARU</b-badge>
                            <b-badge variant="primary" v-else-if="row.item.status.name == 'Berjalan'">BERJALAN</b-badge>
                            <b-badge variant="danger" v-else-if="row.item.status.name == 'Void'">VOID</b-badge>
                            <b-badge variant="success" v-else-if="row.item.status.name == 'Lunas'">LUNAS</b-badge>
                            <b-badge v-else>{{ row.item.status.name }}</b-badge>     
                        </template>
                        <template v-slot:head(status)>
                            Status 
                            <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                        </template>
                        <template v-slot:cell(nilaiPinjamanEfektif)="row">
                            <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanAwal) }}</div>
                            <div class="text-right text-muted smallText">Sisa Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanEfektif) }}</div>
                        </template>
                        <template v-slot:cell(barang)="row">
                            <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                                <p class="mb-0">{{row.item.jenisBarang}}</p>
                                <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                                <!-- <p class="mb-0 smallText text-muted">{{row.item.barang.noPol}}</p> -->
                            </div>
                            <div v-else>
                                <p class="mb-0">{{row.item.jenisBarang}}</p>
                                <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                            </div>
                        </template>
                        <template v-slot:cell(action)="row">
                            <div class="no-wrap">
                                <b-button size="sm" class="mr-2" variant="pgiBtn" name="bayarBtn" @click="checkInquiry(row.item.id, row.item.noFaktur)">
                                    Lihat Faktur
                                </b-button>
                            </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="input.showFromNoFaktur" id="showItemsNoFaktur" @change="onLimitChangeFromNoFaktur" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewTextFromNoFaktur }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPageFromNoFaktur"
                            :total-rows="rowsFromNoFaktur"
                            :per-page="perPageFromNoFaktur"
                            aria-controls="my-table"
                            @input="onPageChangeFromNoFaktur"
                        ></b-pagination>
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">SEARCH ANGGOTA</h6>
                    <div class="mb-4">
                        <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" variant="pgiBtn" class="mr-2">
                            <i class="fa fa-search mr-2"></i>Pilih Anggota
                        </b-button>
                    </div>
                    <div class="daftar-gadai-anggota" v-if="showDaftarGadaiAnggota">
                        <div class="detail-data-wrapper mb-4">
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                                <b-col><strong>{{ anggota.no }}</strong></b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                                <b-col>{{ anggota.jenisIdentitas }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                                <b-col>{{ anggota.noIdentitas }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Nama</b-col>
                                <b-col>{{ anggota.nama }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">No. HP</b-col>
                                <b-col>{{ anggota.noHp }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="4" class="detail-data-label">Alamat</b-col>
                                <b-col>{{ anggota.alamat }}</b-col>
                            </b-row>
                        </div>
                        <div class="detail-data-wrapper mb-4">
                            <h6 class="form-title">DAFTAR GADAI</h6>
                            <b-table bordered hover show-empty
                                :busy="isBusy"
                                :items="daftarGadai" 
                                :fields="fields" 
                                responsive class="mb-3">
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>  Loading data...</strong>
                                    </div>
                                </template>
                                <template v-slot:empty>
                                    Tidak ada data gadai.
                                </template>
                                <template v-slot:cell(status)="row">
                                    <b-badge variant="dark" v-if="row.item.status.name == 'Baru'">BARU</b-badge>
                                    <b-badge variant="primary" v-else-if="row.item.status.name == 'Berjalan'">BERJALAN</b-badge>
                                    <b-badge variant="danger" v-else-if="row.item.status.name == 'Void'">VOID</b-badge>
                                    <b-badge variant="success" v-else-if="row.item.status.name == 'Lunas'">LUNAS</b-badge>  
                                    <b-badge v-else>{{ row.item.status.name }}</b-badge>               
                                </template>
                                <template v-slot:head(status)>
                                    Status 
                                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                                </template>
                                <template v-slot:cell(nilaiPinjamanEfektif)="row">
                                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanAwal) }}</div>
                                    <div class="text-right text-muted small">Sisa Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanEfektif) }}</div>
                                </template>
                                <template v-slot:cell(barang)="row">
                                    <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                                        <!-- <p class="mb-0 smallText text-muted">{{row.item.barang.noPol}}</p> -->
                                    </div>
                                    <div v-else>
                                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                                    </div>
                                </template>
                                <template v-slot:cell(action)="row">
                                    <div class="no-wrap">
                                        <b-button size="sm" variant="pgiBtn" name="bayarBtn" @click="checkInquiry(row.item.id, row.item.noFaktur)">
                                            Lihat Faktur
                                        </b-button>
                                    </div>
                                </template>
                            </b-table>

                            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled />
                                        </template>
                                    </b-form-select>
                                    <span class="ml-2">{{ totalViewText }}</span>
                                </b-input-group>
                                <b-pagination class="mb-0"
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    aria-controls="my-table"
                                    @input="onPageChange"
                                ></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
        <ModalPilihAnggota @anggota-selected="selectAnggota" />
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi gadai yang baru diinput dan belum ditransaksikan. Seluruh gadai BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Transaksi gadai aktif yang sudah dieksekusi dan dicetak SBGnya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi gadai sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">LUNAS</h6>
                <p class="smallText mb-0">Transaksi gadai sudah lunas.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-upload-bukti" title="Upload Bukti" no-close-on-backdrop>
            No. Faktur : {{ activeFaktur }}

            <div class="my-2">
                SBG Awal Gadai
                <div class="d-flex">
                    <b-button class="mr-2" v-if="sbgAwalGadai.path != null" variant="cancelBtn" @click="viewFoto(sbgAwalGadai)">
                        Lihat Foto
                    </b-button>
            
                    <b-button class="mr-2" v-else variant="cancelBtn">
                        Tidak ada bukti
                    </b-button>

                </div>
            </div>
            <div class="my-2">
                SBG Pelunasan
                <div class="d-flex">
                    <b-button class="mr-2" v-if="sbgPelunasan.path != null" variant="cancelBtn" @click="viewFoto(sbgPelunasan)">
                        Lihat Foto
                    </b-button>
                    <b-button class="mr-2" v-else variant="cancelBtn">
                        Tidak ada bukti
                    </b-button>
                </div>
            </div>
            <div class="my-2">
                Kwitansi Pelunasan
                <div class="d-flex">
                    <b-button class="mr-2" v-if="kwitansiPelunasan.path != null" variant="cancelBtn" @click="viewFoto(kwitansiPelunasan)">
                        Lihat Foto
                    </b-button>
                    <b-button class="mr-2" v-else variant="cancelBtn">
                        Tidak ada bukti
                    </b-button>
                </div>
            </div>
            <div class="my-2">
                Nota Hilang
                <div class="d-flex">
                    <b-button class="mr-2" v-if="notaHilang.path != null" variant="cancelBtn" @click="viewFoto(notaHilang)">
                        Lihat Foto
                    </b-button>
                    <b-button class="mr-2" v-else variant="cancelBtn">
                        Tidak ada bukti
                    </b-button>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>
        
        <b-modal id="modal-preview-foto" size="xl"  :title="activeFotoPreview.name">
            <div>
                No. Faktur : {{ activeFaktur }}
            </div>
            <div class="my-2">
                Oleh : {{ activeFotoPreview.createdBy }} , {{ $helper.changeDateFormat(activeFotoPreview.createdAt) }} {{
                    $helper.changeDateFormatGetHour(activeFotoPreview.createdAt) }}
           </div>
            <div class="modal-foto-wrapper">
                <img :src="$baseFilePath + activeFotoPreview.path" alt="Foto">
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import ModalPilihAnggota from '../../../views/gadai/ModalPilihAnggota'

export default {
    name: 'inquiry-faktur',
    components: {
        ModalPilihAnggota,
    },
    data(){
        return{
            isBusy: true,
            isSearch: false,

            activeFaktur:'',
            activeFotoPreview: '',
            foto: [],

            sbgAwalGadai:[],
            sbgPelunasan:[],
            kwitansiPelunasan:[],
            notaHilang:[],

            input: {
                show: 10,
                showFromNoFaktur: 10, 
                // filterNoFaktur: ""
                searchQuery: "",
                searchBy: 0,
            },
            searchByOption: [
                { id: 0, name: "No. Faktur"},
				{ id: 1, name: "IMEI/SN"},
				{ id: 2, name: "No. Polisi"},
				{ id: 3, name: "No. BPKB"},
				{ id: 4, name: "No. Mesin"},
				{ id: 5, name: "No. Rangka"},
                { id: 6, name: "ID Lelang"},
            ],
            anggota: {
                id: null,
                nama: "-",
                no: "-",
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur", sortable:true },
                { key: "jenisPinjaman", label: "Jenis Pinjaman", sortable:true },
                { key: "Barang", label: "Barang" },
                { key: "nilaiPinjamanEfektif", label: "Total Pinjaman", sortable:true },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            daftarGadai: [],
            showDaftarGadaiAnggota: false,
            showListFromNoFaktur: false,
            daftarGadaiFromFaktur: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            currentPageFromNoFaktur: 1,
            perPageFromNoFaktur: 10,
            rowsFromNoFaktur: null,
            totalViewTextFromNoFaktur: "",
            pageFromNoFaktur: '',
            sizeFromNoFaktur: '',
            queryFromNoFaktur: '',
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ''
        }
    }, 
    methods: {
        searchInquiryFaktur(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.searchQuery)){
                this.$helper.toastErr(this, "Mohon isi pencarian dengan benar!")
            }else if(this.input.searchBy == 0){
                this.pageFromNoFaktur = 0
                this.sizeFromNoFaktur = this.input.showFromNoFaktur
                this.queryFromNoFaktur = this.$helper.makeQuery(this.pageFromNoFaktur, this.sizeFromNoFaktur)
                this.queryFromNoFaktur += "&noFaktur="+this.input.searchQuery
                this.isBusy = true
                this.isSearch = true
                this.$axios.get(`gadai-pembayaran/search-faktur-v2/`+this.queryFromNoFaktur).then(response => {
                    this.showListFromNoFaktur = true
                    this.daftarGadaiFromFaktur = response.data.data
                    this.updateTotalItemFromNoFaktur(response.data.total)
                    this.isBusy = false
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSearch = false
                })
            }else{
                this.pageFromNoFaktur = 0
                this.sizeFromNoFaktur = this.input.showFromNoFaktur
                this.queryFromNoFaktur = this.$helper.makeQuery(this.pageFromNoFaktur, this.sizeFromNoFaktur)
				this.queryFromNoFaktur += "&query="+this.input.searchQuery
				this.queryFromNoFaktur += "&searchBy="+this.input.searchBy
                this.isBusy = true
                this.isSearch = true
                this.$axios.get(`gadai-pembayaran/search-others/`+this.queryFromNoFaktur).then(response => {
                    this.showListFromNoFaktur = true
                    this.daftarGadaiFromFaktur = response.data.data
                    this.updateTotalItemFromNoFaktur(response.data.total)
                    this.isBusy = false
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSearch = false
                })
            }
        },
        checkInquiry(id, noFaktur){
            // let gadaiId = id

            // let checkFaktur = this.$axios.get(`gadai-pembayaran/check-faktur/?gadaiId=${gadaiId}`).then(response => {
            //     this.$router.push({path: `${this.$route.path}/${noFaktur}`})
            // })
            // .catch(error => {
            //     this.$helper.parseError(this, error)
            // })
            this.$router.push({path: `${this.$route.path}/${noFaktur}`})
        },
        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },
        selectAnggota(item) {

            this.anggota.id = item.id
            this.anggota.nama = item.nama
            this.anggota.no = item.no
            // this.anggota.jenisIdentitas = item.jenisIdentitas.name
            // this.anggota.noIdentitas = item.noIdentitas

            if (item.identitas && item.identitas.length > 0) {
                this.anggota.jenisIdentitas = item.identitas[0].jenisIdentitas
                this.anggota.noIdentitas = item.identitas[0].noIdentitas
            }
            this.anggota.noHp = item.noHp
            this.anggota.noRumah = item.noRumah
            this.anggota.alamat = item.alamat
            this.anggota.isComplete = item.isComplete

            this.showDaftarGadaiAnggota = true

            //jalanin init get daftar gadai

            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            let getDaftarGadai = this.$axios.get(`nasabah/${this.anggota.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.updateTotalItem(response.data.total)
            })

            this.isBusy = true
            Promise.all([getDaftarGadai]).then(() => {
                // Do nothing
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.isBusy = false
            })

            //hide modal

            this.$bvModal.hide("modal-pilih-anggota")

        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarGadai(){

            this.daftarGadai = []

            this.isBusy = true
            this.$axios.get(`nasabah/${this.anggota.id}/gadai/`+this.query).then(response => {
                this.daftarGadai = response.data.data
                this.updateTotalItem(response.data.total)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDaftarGadai()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarGadai()
            }
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Ambil Data Daftar Gadai From No Faktur -----------------

        getDaftarGadaiFromNoFaktur(){

            this.daftarGadaiFromFaktur = []
            if(this.input.searchBy == 0){
                this.queryFromNoFaktur += "&noFaktur="+this.input.searchQuery
                this.isBusy = true
    
                this.$axios.get(`gadai-pembayaran/search-faktur-v2/`+this.queryFromNoFaktur).then(response => {
                    this.daftarGadaiFromFaktur = response.data.data
                    this.updateTotalItemFromNoFaktur(response.data.total)
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })
            }else{
				this.queryFromNoFaktur += "&query="+this.input.searchQuery
				this.queryFromNoFaktur += "&searchBy="+this.input.searchBy
                this.isBusy = true
              
                this.$axios.get(`gadai-pembayaran/search-others/`+this.queryFromNoFaktur).then(response => {
                    this.daftarGadaiFromFaktur = response.data.data
                    this.updateTotalItemFromNoFaktur(response.data.total)
                   
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })
            }
        },

        uploadBukti(id,item){
            this.activeFaktur = item
            this.fetchSBG(item)
            this.$bvModal.show('modal-upload-bukti')
        },

        fetchSBG(faktur){
            this.$axios.get(`gadai-evidence/?noFaktur=${faktur}`)
            .then(response => {
             this.sbgAwalGadai = response.data[0]
             this.sbgPelunasan = response.data[1]
             this.kwitansiPelunasan = response.data[2]
             this.notaHilang = response.data[3]

             this.sbgAwalGadai.file = []
             this.sbgPelunasan.file = []
             this.kwitansiPelunasan.file = []
             this.notaHilang.file = []
            
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
            }); 
        },

        viewFoto(item){
            this.activeFotoPreview = item
            
            this.$bvModal.show("modal-preview-foto")
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChangeFromNoFaktur(){
            this.sizeFromNoFaktur = this.input.showFromNoFaktur
            this.perPageFromNoFaktur = this.input.showFromNoFaktur
            this.currentPageFromNoFaktur = 1
            this.pageFromNoFaktur = 0
            this.queryFromNoFaktur = this.$helper.makeQuery(0, this.sizeFromNoFaktur)
            this.getDaftarGadaiFromNoFaktur()
        },

        onPageChangeFromNoFaktur(){
            if (this.loading == false){
          
                this.pageFromNoFaktur = this.currentPageFromNoFaktur - 1
                this.queryFromNoFaktur = this.$helper.makeQuery(this.pageFromNoFaktur, this.sizeFromNoFaktur)
                this.getDaftarGadaiFromNoFaktur()
            }
        },

        updateTotalItemFromNoFaktur(total){
            let limitFromNoFaktur = null
            let prevLimitFromNoFaktur = null
            this.perPageFromNoFaktur = this.sizeFromNoFaktur
            this.rowsFromNoFaktur = total
            prevLimitFromNoFaktur = this.pageFromNoFaktur * this.sizeFromNoFaktur + 1
            limitFromNoFaktur = this.pageFromNoFaktur * this.sizeFromNoFaktur + this.sizeFromNoFaktur
            if (limitFromNoFaktur > this.rowsFromNoFaktur) limitFromNoFaktur = this.rowsFromNoFaktur
            this.totalViewTextFromNoFaktur = "Menampilkan "+ prevLimitFromNoFaktur + " - " + limitFromNoFaktur + " dari " + this.rowsFromNoFaktur + " entri"
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

    },
    mounted(){
        this.searchByOption = (localStorage.getItem("menuChildren").includes('PFA') 
        ? [
                { id: 0, name: "No. Faktur"},
				{ id: 1, name: "IMEI/SN"},
				{ id: 2, name: "No. Polisi"},
				{ id: 3, name: "No. BPKB"},
				{ id: 4, name: "No. Mesin"},
				{ id: 5, name: "No. Rangka"},
				{ id: 6, name: "ID Lelang"},
            ]
        : [
                { id: 0, name: "No. Faktur"},
            ]
         )
        this.$refs.inputFilterSearchQuery.focus()
    }
}
</script>
